import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import { provideServerRendering } from '@angular/platform-server';

const nonce = document.querySelector('meta[name="csp-nonce"]')?.getAttribute('content') || '';

bootstrapApplication(AppComponent, {
  ...appConfig,
  providers: [
    ...appConfig.providers,
    provideServerRendering(),
    { provide: 'HYDRATION_DIAGNOSTICS', useValue: true },
  ],
}).catch((err) => console.error(err));